import React from "react";
import SITE from "@/constants/site";
import SITE_IDS from "@/constants/testIds/site";
import { ArrowUpRight, ArrowRight } from "lucide-react";

// The keepsake tiles. The Gallery (the wide featured card above the grid)
// is the one external link — straight to Hello Photography's Pic-Time site —
// and says so. The rest are in-site: the Weekend story page, then the
// filtered photobooth/social views and the full guest album.
const TILES = [
  {
    id: "weekend",
    testId: undefined,
    href: "/story",
    external: false,
    primary: false,
    label: "01 — The Weekend",
    title: "You made this.",
    desc: "The whole weekend the way it happened, from the reel to the last clip of the night.",
    action: "Watch the weekend",
  },
  {
    id: "photobooth",
    testId: SITE_IDS.photoboothCta,
    href: SITE.links.photobooth,
    external: false,
    primary: false,
    label: "02 — Unfiltered",
    title: "The Photobooth",
    desc: "Every strip from the Good Times Roll bus, flattering or not.",
    action: "Enter the booth",
  },
  {
    id: "social",
    testId: SITE_IDS.socialCta,
    href: SITE.links.social,
    external: false,
    primary: false,
    label: "03 — In Motion",
    title: "The Social Reel",
    desc: "Real-time clips from One Take Bridal. The day the way it actually felt.",
    action: "Watch the reel",
  },
  {
    id: "guest-album",
    testId: SITE_IDS.guestAlbumCta,
    href: SITE.links.guestAlbum,
    external: false,
    primary: false,
    label: "04 — Everyone",
    title: "The Guest Album",
    desc: "Everything you all captured. Browse the whole album, and add the photos still sitting on your phone.",
    action: "See it all + add yours",
  },
];

export default function CtaSection() {
  return (
    <section id="keepsakes" data-testid={SITE_IDS.ctaSection} className="section cta">
      <div className="container">
        <div className="cta__head">
          <span className="eyebrow">Keepsakes</span>
          <h2 className="section__title font-display">Relive every frame</h2>
          <p className="section__lede">
            The photographs, and the little moments in between. So the day
            never quite ends.
          </p>
        </div>

        <div className="cta__grid">
          <a
            href={SITE.links.gallery}
            data-testid={SITE_IDS.galleryCta}
            className="cta-card cta-card--primary cta-card--wide"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="cta-card__label">00 — The Professionals</span>
            <span className="cta-card__title font-display">The Wedding Gallery</span>
            <span className="cta-card__desc">
              Every professional photograph from the day, by Hello Photography.
              The full suite should be finished within the next few weeks — for
              now, enjoy the sneak peeks. Opens their gallery site in a new tab.
            </span>
            <span className="cta-card__action">
              Open the gallery site <ArrowUpRight size={18} strokeWidth={1.5} />
            </span>
          </a>
          {TILES.map((tile) => (
            <a
              key={tile.id}
              href={tile.href}
              data-testid={tile.testId}
              className={`cta-card ${tile.primary ? "cta-card--primary" : "cta-card--ghost"}`}
              {...(tile.external
                ? { target: "_blank", rel: "noopener noreferrer" }
                : {})}
            >
              <span className="cta-card__label">{tile.label}</span>
              <span className="cta-card__title font-display">{tile.title}</span>
              <span className="cta-card__desc">{tile.desc}</span>
              <span className="cta-card__action">
                {tile.action}{" "}
                {tile.external ? (
                  <ArrowUpRight size={18} strokeWidth={1.5} />
                ) : (
                  <ArrowRight size={18} strokeWidth={1.5} />
                )}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
